import { useEffect } from "react"
import "./SearchPane.scss"
import { ChevronLeftBlue } from "../../../../common/atoms/Icons/Chat"
import { IconButton } from "../../../../messaging/common/IconButton/IconButton"

interface SearchPaneProps {
    isOpen: boolean
    onClose: () => void
}

export function SearchPane({ isOpen, onClose }: SearchPaneProps) {
    useEffect(() => {
        if (isOpen) {
            const inputEl = document.getElementById("keywords")
            inputEl?.focus()
        }
    }, [isOpen])

    return (
        <div
            className={`SearchPane ${isOpen ? "isOpen" : ""}`}
            data-testid="search-pane-container"
        >
            <div
                className="SearchPane__content"
                data-testid="search-pane-content"
            >
                <div className="SearchPane__header">
                    <IconButton
                        icon={
                            <ChevronLeftBlue
                                width={16}
                                height={16}
                                className="SearchPane__back-icon"
                            />
                        }
                        onClick={onClose}
                        className="SearchPane__backButton"
                        data-testid="search-pane-back-button"
                    />
                    <div
                        id="SearchInputEntry"
                        className="SearchPane__inputContainer"
                    />
                </div>
                <div id="MobileSearchPaneSuggestions" />
            </div>
        </div>
    )
}
